import { GetStaticProps, NextPage } from 'next';

import ConsolidatedLinesPage from '@/views/consolidated-lines/consolidated-lines-page';

const ConsolidatedLines: NextPage = () => {
  return <ConsolidatedLinesPage />;
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {
    namespaces: ['line'],
  },
});

export default ConsolidatedLines;
